/**
 * @generated SignedSource<<79dc532040096135b025d6de42f85b7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSegments_segments$data = ReadonlyArray<{
  readonly arrivalAirportCode: string;
  readonly arrivalDatetime: string;
  readonly departAirportCode: string;
  readonly departDatetime: string;
  readonly id: string;
  readonly " $fragmentType": "FlightSegments_segments";
}>;
export type FlightSegments_segments$key = ReadonlyArray<{
  readonly " $data"?: FlightSegments_segments$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSegments_segments">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FlightSegments_segments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departAirportCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalAirportCode",
      "storageKey": null
    }
  ],
  "type": "FlightSegment",
  "abstractKey": null
};

(node as any).hash = "6b85cc13b4055ffa39fa0c7fd02a8e57";

export default node;
